// Export a Proxy that accesses jQuery at runtime instead of import time
// This is necessary because ES6 modules evaluate exports when parsed,
// but jQuery might not be loaded yet at that point
const jQueryProxy = new Proxy(function() {}, {
  // Handle $(selector) or $(function) calls
  apply(target, thisArg, args) {
    const $ = window.jQuery || window.$;
    if (!$) {
      console.error('jQuery is not available. window.jQuery:', window.jQuery, 'window.$:', window.$);
      throw new Error('jQuery is not loaded. Make sure WordPress jQuery is enqueued.');
    }
    return $.apply(thisArg, args);
  },
  // Handle $.ajax, $.fn, etc.
  get(target, prop) {
    const $ = window.jQuery || window.$;
    if (!$) {
      console.error('jQuery is not available. window.jQuery:', window.jQuery, 'window.$:', window.$);
      throw new Error('jQuery is not loaded. Make sure WordPress jQuery is enqueued.');
    }
    const value = $[prop];
    return typeof value === 'function' ? value.bind($) : value;
  }
});

// Helper function to wait for jQuery to be available
export function waitForJQuery() {
  return new Promise((resolve) => {
    if (window.jQuery || window.$) {
      resolve(window.jQuery || window.$);
      return;
    }
    
    const checkInterval = setInterval(() => {
      if (window.jQuery || window.$) {
        clearInterval(checkInterval);
        resolve(window.jQuery || window.$);
      }
    }, 50);
  });
}

export default jQueryProxy;
